import label from "fragments/vendors/label"
import { gql } from "graphql-tag"

const ADD_LABEL = gql`
  ${label}

  mutation addLabel($labelAddInput: LabelAddInput!) {
    addLabel(labelAddInput: $labelAddInput) {
      ...Label
    }
  }
`

export default ADD_LABEL
